export * from './detail-table-item.interface';
